module.exports = __webpack_public_path__ + "img/qr-bag.3287bada.png";